import { RegisteredWidget } from '@dotpe/kui/styles/registerWidgetForDnD';
import { INITIALIZE_JSON_WIDGETS_DATA, SET_DRAFT_THEME_COMPONENTS } from '../actionTypes';

interface IJSONWidgetsReducer {
  widgets: Record<string, any>;
  isWidgetLoaded: boolean;
  widgetTemplateLibraryMap: Record<string, RegisteredWidget>;
  widgetTemplateLibraryList: Array<RegisteredWidget>;
  widgetsTemplateConfigs: any;
  themeComponents: any;
  globalStyle: null | Record<string, any>;
  pageStyle: null | Record<string, any>;
  jsonPageWidgetData: null | Record<string, any>;
}

const initialState: IJSONWidgetsReducer = {
  widgets: {},
  isWidgetLoaded: false,
  widgetTemplateLibraryMap: {},
  widgetTemplateLibraryList: [],
  widgetsTemplateConfigs: {},
  themeComponents: null,
  globalStyle: null,
  pageStyle: null,
  jsonPageWidgetData: null,
};

const widgetsReducer = (state: IJSONWidgetsReducer = initialState, action) => {
  switch (action.type) {
    case INITIALIZE_JSON_WIDGETS_DATA:
      return { ...state, ...(action.data as IJSONWidgetsReducer) };
    case SET_DRAFT_THEME_COMPONENTS:
      return { ...state, themeComponents: action.data };
    default:
      return state;
  }
};

export default widgetsReducer;
